// Direct Write compatibility only. Agentic Write owns its separate alias policy.
export const RETIRED_DIRECT_WRITE_MODELS = Object.freeze({ mistrallarge: "excellent", balanced: "excellent", claude3haiku: "claude55haiku", claude35haiku: "claude55haiku", gpt41nano: "gpt56luna" });

export function resolveRetiredDirectWriteModel(model) {
  return typeof model === "string" ? RETIRED_DIRECT_WRITE_MODELS[model.trim().toLowerCase()] || model : model;
}

export function resolveRetiredDirectWritePluginId(id) {
  if (typeof id !== "string") return id;
  return id.replace(/^(documentPlugins\/writeClaude3\/(?:auto|guided)\/)claude(?:3|35)haiku$/i, "$1claude55haiku").replace(/^(documentPlugins\/write\/(?:auto|guided)\/)([^/]+)$/i,
    (match, prefix, model) => Object.hasOwn(RETIRED_DIRECT_WRITE_MODELS, model.toLowerCase()) ? `${prefix}${RETIRED_DIRECT_WRITE_MODELS[model.toLowerCase()]}` : match);
}

// Persisted Draft selections from older clients keep their intended model family.
export const RETIRED_DRAFT_MODES = Object.freeze({ GPT_4_TURBO: "EXCELLENT", GPT_4_1_NANO: "GPT_5_6_LUNA" });

const RETIRED_DRAFT_PROSE_MODES = Object.freeze({
  CLAUDE_3_HAIKU: "CLAUDE_5_5_HAIKU",
  CLAUDE_3_5_HAIKU: "CLAUDE_5_5_HAIKU",
});

export function resolveRetiredDraftProseMode(model) {
  return Object.hasOwn(RETIRED_DRAFT_PROSE_MODES, model) ? RETIRED_DRAFT_PROSE_MODES[model] : model;
}

export function resolveRetiredDraftMode(model) {
  return Object.hasOwn(RETIRED_DRAFT_MODES, model) ? RETIRED_DRAFT_MODES[model] : resolveRetiredDraftProseMode(model);
}

// Persisted Draft requests from older clients keep working with established modes.
export function resolveRetiredDraftEngine(engine) {
  if (engine === "claude-3-haiku" || engine === "claude-3-5-haiku") return "claude-5-5-haiku";
  if (engine === "mistral-large-2512") return "claude-4-6-sonnet";
  if (engine === "gpt-4-turbo") return "ballad-1.1-draft";
  if (engine === "gpt-4.1-nano") return "gpt-5.6-luna";
  return engine;
}
